import type { Item } from "../types.js";
import type { FileApi } from "./shared-api/shared-api-context.js";

export type FieldUpdate = { fieldId: number; value: string };

export const updateTaskFields = async (fileApi: FileApi, taskId: number, fields: FieldUpdate[]) => {
  const taskResponse = await fileApi.client.GET("/api/Task/{taskId}", {
    params: { path: { taskId } },
  });

  if (taskResponse.error || !taskResponse.data) {
    throw taskResponse.error || new Error("Task not found");
  }

  const currentTask = taskResponse.data;
  const updatedTaskFields = [...(currentTask.taskFields ?? [])];

  fields.forEach(({ fieldId, value }) => {
    const fieldIndex = updatedTaskFields.findIndex((field) => field.fieldId === fieldId);
    if (fieldIndex >= 0) {
      updatedTaskFields[fieldIndex] = { ...updatedTaskFields[fieldIndex], fieldId, value };
    } else {
      updatedTaskFields.push({ fieldId, value });
    }
  });

  const response = await fileApi.client.PUT("/api/Task/{taskId}", {
    params: { path: { taskId } },
    body: {
      workflowId: currentTask.workflowId,
      name: currentTask.name,
      path: currentTask.path,
      taskFields: updatedTaskFields,
    },
  });

  if (response.error) {
    throw response.error;
  }

  return response.data;
};

export const updateItemFields = async (fileApi: FileApi, item: Item, fields: FieldUpdate[]) => {
  const updatedTaskItemFields = [...(item.taskItemFields ?? [])];

  fields.forEach(({ fieldId, value }) => {
    const fieldIndex = updatedTaskItemFields.findIndex((field) => field.fieldId === fieldId);
    if (fieldIndex >= 0) {
      updatedTaskItemFields[fieldIndex] = {
        ...updatedTaskItemFields[fieldIndex],
        fieldId,
        value,
      };
    } else {
      updatedTaskItemFields.push({ fieldId, value });
    }
  });

  const response = await fileApi.client.PUT("/api/task/{taskId}/item/{itemId}", {
    params: {
      path: {
        taskId: item.taskId,
        itemId: item.id,
      },
    },
    body: {
      taskId: item.taskId,
      name: item.name,
      path: item.path,
      statusCode: item.statusCode,
      taskItemFields: updatedTaskItemFields,
      fileContentHash: null, //TODO: Placeholder for Future Fix...
    },
  });

  if (response.error) {
    throw new Error("Failed to update item");
  }

  return response.data;
};
